
import { 
    Container,
    Row,
    Col
} from "react-bootstrap";

function PDFPage5(props: any) {

    let backGroundColor = (color:any) =>{
        switch (color) {
            case 'green':
                return '#7fffb6';
            case 'yellow':
                return '#ffff00';
            default:
                return '#7fffb6';
        }
    }

    return (
        <>
            <Container fluid className="text-left page-break cu-pt-10">
                <h3 className="cu-fs-18">{props.TranslateString("Analyysin yhteenveto")} ​</h3>
                <Row className="mx-lg-5">
                    <Col sm={8}>
                        <table className="table table-borderless cu-fs-16">
                            <tbody>
                                <tr>
                                    <th className="cu-bg-green2 cu-text-lightgreen2 text-center cu-h-100 cu-border-radius-12 d-xy-center">
                                        {props.TranslateString("Loan to Value - indikaatio​")}
                                    </th>
                                    <td>&emsp;</td>
                                    <td className="text-dark cu-width-80p cu-border-radius-12" style={{background:backGroundColor(props?.ltvDetails?.loanData_total?.ltv_summary_color)}}>
                                    <ul>
                                       <li>{props?.ltvDetails?.loanData_total?.ltv_summary_value || ""}</li>
                                    </ul>
                                    </td>
                                </tr>
                                <tr><td colSpan={3}></td></tr>
                                <tr>
                                    <th className="cu-bg-green2 cu-text-lightgreen2 text-center cu-h-100 cu-border-radius-12 d-xy-center">
                                        {props.TranslateString("Maksuvalmius​")}
                                    </th>
                                    <td>&emsp;</td>
                                    <td className="text-dark cu-width-80p cu-border-radius-12" style={{background:backGroundColor(props?.data?.financial_color)}}>
                                        <ul>
                                            <li>{props?.data?.financial_summary || ""}​</li>
                                        </ul>
                                    </td>
                                </tr>
                                <tr><td colSpan={3}></td></tr>
                                <tr>
                                    <th className="cu-bg-green2 cu-text-lightgreen2 text-center cu-h-100 cu-border-radius-12 d-xy-center">
                                        {props.TranslateString("Osakkaat")}
                                    </th>
                                    <td>&emsp;</td>
                                    <td className="text-dark cu-width-80p cu-border-radius-12" style={{background:backGroundColor(props?.data?.shareholder_color)}}>
                                        <ul>
                                            {
                                                props?.data?.shareholder_summary?.map((element:any)=>{
                                                    return (<li key={Math.random()}>{element}​</li>);
                                                })
                                            }
                                        </ul>
                                    </td>
                                </tr>
                                <tr><td colSpan={3}></td></tr>
                                
                                <tr>
                                    <th className="cu-bg-green2 cu-text-lightgreen2 text-center cu-h-100 cu-border-radius-12 d-xy-center">
                                        {props.TranslateString("PTS")}
                                    </th>
                                    <td>&emsp;</td>
                                    
                                    <td className="text-dark cu-width-80p cu-border-radius-12" style={{background:backGroundColor(props?.ptsSummaryColor)}}>
                                        <ul>
                                            <li>{props?.ptsSummary || ""}</li>
                                            {props?.ptsSummaryTwo  && <li>{props?.ptsSummaryTwo}</li>}
                                            {props?.ptsSummaryThree  && <li>{props?.ptsSummaryThree}</li>}
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Col>
                    <Col className="d-flex align-items-center justify-content-center  cu-fs-16">
                        <div>
                            <div className="d-flex align-items-center">
                                <div className="cu-box-height-30px cu-bg-lightgreen2 cu-border-radius-12">&emsp;</div>
                                <div>&emsp;{props.TranslateString("Ei huomioitavaa")}​</div>
                            </div>
                            &nbsp;
                            <div className="d-flex align-items-center">
                                <div className="cu-box-height-30px cu-bg-yellow cu-border-radius-12">&emsp;</div>
                                <div>&emsp;{props.TranslateString("Huomioitavaa​")}</div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default PDFPage5;